import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {

  return originalPush.call(this, location).catch(err => err)

}
export default new Router({
  mode: 'history',
  // base: 'portal',
  routes: [
    {
      path: '/',
      name: '首页',
      component: () => import('@/pages/Index')
    },{
      path: '/recommend',
      name: '集团介绍',
      component: () => import('@/pages/groupInfo/recommend')
    },{
      path: '/history',
      name: '发展历程',
      component: () => import('@/pages/groupInfo/history')
    },{
      path: '/culture',
      name: '企业文化',
      component: () => import('@/pages/groupInfo/culture')
    },{
      path: '/honor',
      name: '集团荣誉',
      component: () => import('@/pages/groupInfo/honor')
    },{
      path: '/person',
      name: '公司治理',
      component: () => import('@/pages/groupInfo/person')
    },{
      path: '/investor',
      name: '投资者关系',
      component: () => import('@/pages/groupInfo/investor')
    },{
      path: '/join',
      name: '招贤纳士',
      component: () => import('@/pages/aboutUs/join')
    },{
      path: '/contact',
      name: '联系我们',
      component: () => import('@/pages/aboutUs/contact')
    },{
      path: '/business',
      name: '业务支撑体系',
      component: () => import('@/pages/marketing/business')
    },{
      path: '/platform_0',
      name: '互娱权益平台',
      component: () => import('@/pages/marketing/platform_0')
    },{
      path: '/platform_1',
      name: '广告营销平台',
      component: () => import('@/pages/marketing/platform_1')
    },{
      path: '/platform_2',
      name: 'SaaS服务平台',
      component: () => import('@/pages/marketing/platform_2')
    },{
      path: '/platform_3',
      name: '彩票支撑平台',
      component: () => import('@/pages/marketing/platform_3')
    },{
      path: '/goods',
      name: '商品交付服务',
      component: () => import('@/pages/spread/goods')
    },{
      path: '/advert',
      name: '商品交付服务',
      component: () => import('@/pages/spread/advert')
    },{
      path: '/game',
      name: '游戏联运推广',
      component: () => import('@/pages/spread/game')
    },{
      path: '/lottery',
      name: '彩票运营支撑',
      component: () => import('@/pages/spread/lottery')
    },{
      path: '/shop',
      name: '门店增值赋能',
      component: () => import('@/pages/spread/shop')
    },{
      path: '/notice/:isOpen?',
      name: '公司通告',
      component: () => import('@/pages/investor/notice')
    },{
      path: '/file',
      name: '招股文件',
      component: () => import('@/pages/investor/file')
    },{
      path: '/report',
      name: '定期报告',
      component: () => import('@/pages/investor/report')
    },{
      path: '/news',
      name: '公司新闻',
      component: () => import('@/pages/investor/news')
    },{
      path: '/telephone',
      name: '投资者热线',
      component: () => import('@/pages/investor/telephone')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js